/* eslint-disable @typescript-eslint/ban-ts-comment */
import DOMPurify from "dompurify";
import Parser, { DOMNode, Element } from "html-react-parser";
import { FC } from "react";

import SetStyleFromSrc from "web/Pages/PageGenerator/utils/setStyleFromSrc";

import useHTMLLink from "web/hooks/useHTMLLink";

import jsonParse from "web/utils/data/parser/string/jsonParse";

import { IParsedParameter, IParsedParameters } from "web/types/PageGenerator";

import ErrorBoundary from "../../../Layout/ErrorBoundary";

const parseHtml = (
  content: string | Node | IParsedParameter,
  id: number,
  scripts: React.JSX.Element[]
) => {
  const parserOptions = {
    replace(domNode: DOMNode) {
      if ((domNode as Element).name === "script") {
        return null;
      }

      if (
        (domNode as Element).name === "link" &&
        (domNode as Element).attribs &&
        (domNode as Element).attribs.href
      ) {
        const styleSrc = (
          <SetStyleFromSrc
            key={`lp-generator-admin-scripts${id}`}
            href={(domNode as Element).attribs.href}
          />
        );
        scripts.push(styleSrc);
      }

      return null;
    },
  };

  if (typeof content === "string") {
    Parser(content, parserOptions);
  }
};

interface IPageGeneratorHtmlExtendedProps {
  params: string;
  isMobile: boolean;
  id: number;
}

const PageGeneratorHtmlExtended: FC<IPageGeneratorHtmlExtendedProps> = ({
  params,
  id,
  isMobile,
}) => {
  const contentRef = useHTMLLink();

  const scripts: React.JSX.Element[] = [];
  const data: IParsedParameters = jsonParse(params);
  const style = isMobile
    ? {
        marginTop: "30px",
        marginBottom: "30px",
      }
    : {
        marginTop: "60px",
        marginBottom: "60px",
      };

  if (data?.content) {
    parseHtml(data.content, id, scripts);
    return (
      <>
        <div
          data-t1="pageGeneratorHtmlExtended"
          style={style}
          className="container"
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(data.content as string | Node),
          }}
          // @ts-ignore
          ref={contentRef}
        />
        {scripts}
      </>
    );
  }
  return null;
};

interface IPageGeneratorHtmlExtendedContainerErrorProps {
  params: string;
  isMobile?: boolean;
  id: number;
}

const PageGeneratorHtmlExtendedContainerError: FC<
  IPageGeneratorHtmlExtendedContainerErrorProps
> = ({ isMobile = false, params, id }) => {
  return (
    <ErrorBoundary>
      <PageGeneratorHtmlExtended isMobile={isMobile} id={id} params={params} />
    </ErrorBoundary>
  );
};

export default PageGeneratorHtmlExtendedContainerError;
